<template>
    <div class="datamain">
        <div class="contentbox">
            <div :class="allspflag ? ' lefthide' : 'leftbox'">
                <div :class="menu == item.name ? 'menuitem med' : 'menuitem'" v-for="(item, i) in menulist" :key="i"
                    @click="menuchange(item.name)">
                    <div class="icon"><img :src="menu == item.name ? item.iconed : item.icon" /></div>
                    <div class="name">{{ item.name }}</div>
                </div>
            </div>
            <template v-if="menu != '视频'">
                <div class="rightbox">
                     <div class="select-row" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px;">
                            <div class="selectbox">
                                <el-select v-model="selectedGreenhouseId" size="mini" @change="handleGreenhouseChange" placeholder="请选择大棚"
                                    v-if="greenhouseList.length > 0">
                                    <el-option v-for="item in greenhouseList" :key="item.id" :label="item.serialNumber" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="selectbox">
                                <el-select v-model="selectedDeviceClassify" size="mini" @change="handleDeviceClassifyChange" placeholder="请选择设备类型"
                                    v-if="deviceClassifyList.length > 0">
                                    <el-option v-for="item in deviceClassifyList" :key="item.classifyId" :label="item.classifyName" :value="item.classifyName">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    <div class="databox" :style="{height: menu == '大气' ? '165px' : '120px'}">
                        <div class="el-icon-refresh refbox" @click="getshebeidatalist(1)"></div>
                       
                        <!-- <div class="selectbox" v-if="menu == '大气'">
                            <el-select v-model="sbname" size="mini" @change="sbtypechange" placeholder="请选择"
                                v-if="sblist.length > 1">
                                <el-option v-for="item in sblist" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </div> -->

                        <el-carousel :interval="5000" style="height: 100%;" arrow="always" v-if="menu == '大气'">
                            <el-carousel-item v-for="item in valuelist" :key="item.id">
                                <div class="titname">{{ item.deviceName }}</div>
                                <div class="valuebox">
                                    <div class="valueitem" v-for="(sitem, sindex) in getCurrentValueKeyList(item.deviceName)" :key="'valueitem-' + item.id + '-' + sindex"
                                        :style="{ width: 'calc(100% / ' + (getCurrentValueKeyList(item.deviceName) ? getCurrentValueKeyList(item.deviceName).length : 0) + ' - 5px)', backgroundColor: item.deviceName + sitem.name == talkitem ? '#c0e2f4' : '' }"
                                        @click="gocreatque(sitem.name + '横向对比查看', item.deviceName + sitem.name)">
                                        <div class="name">{{ sitem.name }}</div>
                                        <div class="value">{{ item[sitem.value] }}</div>
                                        <div class="unit">{{ sitem.unit }}</div>
                                    </div>
                                </div>
                                <div class="uptime">更新时间：{{ item.time }}</div>
                            </el-carousel-item>
                        </el-carousel>
                        <el-carousel :interval="5000" style="height: 100%;" arrow="always" v-else>
                            <el-carousel-item v-for="item in valuelist" :key="item.id">
                                <div class="titname" style="margin-bottom: 0;color: #95671f;">{{ item.deviceName }}</div>
                                <div class="valuebox_t">
                                    <div class="valueitem" v-for="(sitem, sindex) in getCurrentValueKeyList(item.deviceName)" :key="'valueitem-t-' + item.id + '-' + sindex"
                                    :style="{ width: 'calc(100% / ' + (getCurrentValueKeyList(item.deviceName) ? getCurrentValueKeyList(item.deviceName).length : 0) + ' - 5px)', backgroundColor: item.deviceName + sitem.name == talkitem ? '#c0e2f4' : '' }"
                                        @click="gocreatque(sitem.name + '横向对比查看', item.deviceName + sitem.name)">
                                        <div class="name">{{ sitem.name }}</div>
                                        <div class="value">{{ item[sitem.value] }}<span>{{ sitem.unit }}</span></div>
                                    </div>
                                </div>
                                <div class="uptime" style="padding-top: 2px;">更新时间：{{ item.time }}</div>
                            </el-carousel-item>
                        </el-carousel>

                    </div>

                </div>
                <!-- :style="{ height: allspflag ? 'calc(100% - 10px)' : 'calc(100% - 175px)' }" -->
                <div class="talkbox"
                    :style="{ height: menu == '大气' ? 'calc(100% - 290px)' : 'calc(100% - 250px)', width: allspflag ? 'calc(100% - 20px)' : 'calc(100% - 80px)', background: menu == '大气' ? 'linear-gradient(180deg, #B0D393 0%, #b2d49903 100%)' : 'linear-gradient(180deg, #e2c69b 0%, #b2d49903 100%)' }">
                    <div class="talktitle"><i @click="clickallap"
                            :class="allspflag ? 'allap el-icon-s-unfold' : 'allap el-icon-s-fold'"></i><span
                            @click="createtalk">实时精准感知关键环境数据</span>
                    </div>
                    <div class="content" id="resultbox">

                        <div class="zhuibox">
                            <!-- 轮播组件替代分页 -->
                            <el-carousel :interval="5000" v-if="isfirst && quelist.length > 0" class="question-carousel">
                                <el-carousel-item v-for="(pageQuestions, pageIndex) in getQuestionPages()" :key="pageIndex">
                                    <div class="zhuiitem" v-for="(item, i) in pageQuestions" :key="i" @click="sendmes(item)">
                                        {{ item }}
                                    </div>
                                </el-carousel-item>
                            </el-carousel>
                            
                            <span v-for="(item, i) in talklist" :key="i">
                                <div class="useritem" v-if="item.message && item.message.length > 0">
                                    <div class="userleft"><img src="@/assets/img/home/user.png" /></div>
                                    <div class="userright">
                                        <div class="usertext">
                                            {{ item.message }}
                                            <div v-if="item.talkimgurl" class="userimg"><img style="max-width: 80%;"
                                                    :src="item.talkimgurl" /></div>
                                        </div>

                                    </div>
                                </div>
                                
                                <div class="aiitem">
                                    
                                    <div class="aileft"><img src="@/assets/img/head.png" /></div>
                                    <div class="airight">
                                        <div class="working" v-if="item.reply_content && item.reply_content.workflowData && item.reply_content.workflowData.workflowSteps">
                                            <div class="workflow-step" v-for="(step, index) in item.reply_content.workflowData.workflowSteps" :key="'step-' + i + '-' + index">
                                                <div class="step-content">
                                                <div class="step-info">
                                                    <div :class="['step-icon', step.status]">{{ step.status === 'loading' ? '⏳' : '✅' }}</div>
                                                    <span class="step-title">{{ step.title }}</span>
                                                </div>
                                                <span :class="['step-time', step.status]">{{ step.status === 'loading' ? '执行中...' : step.elapsedTime.toFixed(2) + '秒' }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="airesultimg"
                                            v-if="item.reply_content && (item.reply_content.imagereplys || item.reply_content.imagereply)">
                                            <!-- <img v-for="imgitem in item.reply_content.resultimgs" :key="imgitem" :src="imgitem" /> -->
                                            <el-image
                                                v-for="(imgitem, imgIndex) in (item.reply_content.imagereplys || [item.reply_content.imagereply])"
                                                :key="'img-' + i + '-' + imgIndex"
                                                :src="imgitem.replace('http://47.96.179.72:11454/', 'http://strawberryai.web.shuzhiren.com/klgapi/')"
                                                :preview-src-list="srcList">
                                            </el-image>
                                        </div>
                                        <div class="aitext">

                                            <el-button type="text"
                                                v-if="item.reply_content.result1 == '' && !item.reply_content.thinktxt"
                                                icon="el-icon-loading">生成中..</el-button>
                                            <span v-else>
                                                <!-- <div>总结：</div> -->
                                                <div class="resultbox"
                                                    v-if="item.reply_content.thinktxt && item.reply_content.thinktxt.length > 0">
                                                    <el-collapse v-model="activeNames">
                                                        <el-collapse-item name="1">
                                                            <template slot="title">
                                                                <i class="el-icon-s-opportunity"></i>思考过程
                                                            </template>
                                                            <vue-markdown :source="item.reply_content.thinktxt"
                                                                class="custom-markdown"></vue-markdown>
                                                        </el-collapse-item>
                                                    </el-collapse>

                                                    <!-- {{ item.reply_content.thinktxt }} -->
                                                </div>

                                                <!-- 显示图表前的内容 -->
                                                <vue-markdown v-if="item.reply_content.result1" :source="item.reply_content.result1"
                                                    class="custom-markdown"></vue-markdown>

                                                <!-- 显示echarts图表 -->
                                                <div  v-if="echartsOutputStatus != 0 || item.reply_content.echartsCharts" v-loading="echartsOutputStatus == 1"   class="echarts-container"> 
                                                     <!-- element-loading-text="图表正在加载" -->
                                                    
                                                    <echarts-renderer
                                                        :charts-data="item.reply_content.echartsCharts"
                                                        chart-width="100%"
                                                        chart-height="300px">
                                                    </echarts-renderer>
                                                </div>

                                                <!-- 显示图表后的内容 -->
                                                <vue-markdown v-if="item.reply_content.result2" :source="item.reply_content.result2"
                                                    class="custom-markdown"></vue-markdown>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>

                    </div>

                </div>
                <div :class="allspflag ? 'sendboxhide' : 'sendbox'">
                    <!-- <div class="photo" @click="triggerUpload">
                        <img src="@/assets/img/home/photo.png" />
                        <input id="fileInput" type="file" style="display: none" ref="fileInput"
                            @change="handleFileChange" />
                    </div> -->
                    <!-- <div @click="opensd" :class="issd ? 'skbtn skbtned' : 'skbtn'">DS-R1</div> -->
                    <div class="inputbox">
                        <div class="talkimg" v-if="talkimgurl" @click="talkimgurl = ''">
                            <div class="delbox">×</div><img :src="talkimgurl" />
                        </div>
                        <input type="text" id="qmess" class="sendinput" placeholder="点我智问" />
                        <div @click="stopconn" v-if="isconn" class="delbtn"><i class="el-icon-video-pause"></i></div>
                    </div>
                    
                    <!-- <div style="margin-left: 10px;" class="skbtn skbtned">联网</div> -->
                    <div class="btnbox" style="margin-left: 10px;" @click="senmessage"><img src="@/assets/img/home/send.png" alt=""></div>
                </div>
            </template>
            <div class="videobox" v-else>
                <!-- 监控大棚选择框 -->
                <div class="camera-selector" v-if="cameraGreenhouseList.length > 1">
                    <el-select v-model="selectedCameraGreenhouse" size="small" placeholder="请选择大棚" @change="handleCameraGreenhouseChange">
                        <el-option v-for="greenhouse in cameraGreenhouseList" :key="greenhouse" :label="greenhouse" :value="greenhouse">
                        </el-option>
                    </el-select>
                </div>
                
                <!-- 显示选中的大棚监控 -->
                <div class="monitor-container" v-if="selectedCameraGreenhouse && cameralist[selectedCameraGreenhouse]">
                    <div class="greenhouse-title">
                        <h3>{{ selectedCameraGreenhouse }}</h3>
                    </div>
                    <div class="monitor-grid">
                        <div class="monitor-item" v-for="monitor in cameralist[selectedCameraGreenhouse]" :key="monitor.monitorName">
                            <div class="monitor-name">{{ monitor.monitorName }}</div>
                            <iframe 
                                class="monitor-iframe" 
                                :src="monitor.monitorUrl" 
                                frameborder="0" 
                                allowfullscreen
                                loading="lazy">
                            </iframe>
                        </div>
                    </div>
                </div>
                
                <!-- 如果只有一个大棚，直接显示 -->
                <div class="monitor-container" v-else-if="Object.keys(cameralist).length === 1">
                    <div class="greenhouse-title">
                        <h3>{{ Object.keys(cameralist)[0] }}</h3>
                    </div>
                    <div class="monitor-grid">
                        <div class="monitor-item" v-for="monitor in cameralist[Object.keys(cameralist)[0]]" :key="monitor.monitorName">
                            <div class="monitor-name">{{ monitor.monitorName }}</div>
                            <iframe 
                                class="monitor-iframe" 
                                :src="monitor.monitorUrl" 
                                frameborder="0" 
                                allowfullscreen
                                loading="lazy">
                            </iframe>
                        </div>
                    </div>
                </div>
                
                <div v-if="Object.keys(cameralist).length === 0" class="no-data">
                    暂无视频监控数据
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import router from '../router'
import axios from "axios";
import Vue from 'vue';
import { getbcmsblist, getsbdatalist, getweatherdata, getGreenhouseList, getDeviceClassifyList, getMonitorList, getUserGreenhouseList } from '@/api/bot'
import qs from 'qs'
import VueMarkdown from 'vue-markdown'
import { baseUrl } from '@/axios/baseUrl'
import m1 from '@/assets/img/home/m1.png'
import m1ed from '@/assets/img/home/m1ed.png'
import m2 from '@/assets/img/home/m2.png'
import m2ed from '@/assets/img/home/m2ed.png'
import m3 from '@/assets/img/home/m3.png'
import m3ed from '@/assets/img/home/m3ed.png'
import m4 from '@/assets/img/home/m4.png'
import m4ed from '@/assets/img/home/m4ed.png'
import { off } from 'process';
import EchartsRenderer from '@/components/EchartsRenderer.vue'
export default {
    name: 'index',
    components: { VueMarkdown, EchartsRenderer },
    data() {
        return {
            menu: '大气',
            issd: false,
            sblist: [],
            valuelist: [],
            eventSource: null,
            talklist: [],
            isfirst: true,
            srcList: [],
            sbname: '',
            isconn: false,
            weatherdata: [],
            activeNames: ['1'],
            echartsOutputStatus: 0,
            tenantId: '',
            userId: '',
            greenhouseList: [], // 大棚列表
            deviceClassifyList: [], // 设备类型列表
            selectedGreenhouseId: '', // 选中的大棚ID
            selectedDeviceClassify: '', // 选中的设备类型

            menulist: [{
                icon: m1,
                iconed: m1ed,
                name: '大气'
            }, {
                icon: m2,
                iconed: m2ed,
                name: '土壤'
            }, {
                icon: m3,
                iconed: m3ed,
                name: '视频'
            }, {
                icon: m4,
                iconed: m4ed,
                name: '设备'
            }],
            valuekeylist: {
                "大气环境监测传感器": [{
                    name: '温度',
                    value: 'temp',
                    unit: '℃',
                }, {
                    name: '湿度',
                    value: 'humi',
                    unit: '%',
                }, {
                    name: '二氧化碳',
                    value: 'co2',
                    unit: 'ppm',
                }, {
                    name: '光照',
                    value: 'light',
                    unit: 'Lux',
                }],
                "土壤氮磷钾传感器": [{
                    name: '含氮量',
                    value: 'nitrogen',
                    unit: 'mg/kg',
                }, {
                    name: '含磷量',
                    value: 'phosphorus',
                    unit: 'mg/kg',
                }, {
                    name: '含钾量',
                    value: 'potassium',
                    unit: 'mg/kg',
                }],
                "土壤温湿度EC传感器": [{
                    name: '含水率',
                    value: 'water',
                    unit: '%RH',
                }, {
                    name: '温度',
                    value: 'temp',
                    unit: '℃',
                }, {
                    name: '电导率',
                    value: 'conductivity',
                    unit: 'us/cm',
                }],
                "土壤PH传感器": [{
                    name: 'PH值',
                    value: 'ph',
                    unit: '-',
                }],
                "气象": [{
                    name: '温度',
                    value: 'temp',
                    unit: '℃',
                }, {
                    name: '湿度',
                    value: 'humi',
                    unit: '%',
                }, {
                    name: '大气压',
                    value: 'pressure',
                    unit: 'KPa',
                }, {
                    name: '光照',
                    value: 'light',
                    unit: 'Lux',
                }]
            },
            quelist: [],
            talkguanlianid: '',
            allspflag: false,
            talkitem: '',
            talkimgurl: '',
            cameralist: {}, // 视频监控数据，按大棚名称分类
            selectedCameraGreenhouse: '', // 选中的监控大棚
            cameraGreenhouseList: [], // 监控大棚列表
            workflowSteps: [], // 工作流步骤数据
        }
    },
    computed: {
        // 根据设备名称判断应该使用哪个参数列表
        getCurrentValueKeyList() {
            return (deviceName) => {
                if (!deviceName) return []
                
                // 根据设备名称关键词判断
                if (deviceName.includes('氮磷钾') || deviceName.includes('NPK')) {
                    return this.valuekeylist['土壤氮磷钾传感器'] || []
                } else if (deviceName.includes('温湿') || deviceName.includes('EC')) {
                    return this.valuekeylist['土壤温湿度EC传感器'] || []
                } else if (deviceName.includes('PH') || deviceName.includes('ph')) {
                    return this.valuekeylist['土壤PH传感器'] || []
                } else if (deviceName.includes('大气') || deviceName.includes('环境') ) {
                    return this.valuekeylist['大气环境监测传感器'] || []
                } else if (deviceName.includes('气象') || deviceName.includes('40399572')) {
                    return this.valuekeylist['气象'] || []
                }
                
                // 默认返回空数组
                return []
            }
        },
        

    },
    mounted() {
        this.getUrlParams()
        this.getshebeilist()
        this.loadGreenhouseList()
        // 初始化问题列表
        this.quelist = this.getDynamicQuelist()
    },
    methods: {
        // 获取问题分页
        getQuestionPages() {
            const pages = []
            const pageSize = 4
            
            for (let i = 0; i < this.quelist.length; i += pageSize) {
                pages.push(this.quelist.slice(i, i + pageSize))
            }
            
            return pages
        },
        
        getUrlParams() {
            // 从URL中获取租户ID和用户ID
            const urlParams = this.$route.query
            console.log(urlParams)
            // 直接使用默认值，不再需要登录验证
            this.tenantId = urlParams.tenantId || '1'
            this.userId = urlParams.userId || '1'
            
            // 从URL中获取token参数并替换原来的token
            if (urlParams.t) {
                const oldToken = localStorage.getItem('token')
                
                localStorage.setItem('token', urlParams.t)
            }
            
            console.log('获取到的参数:', this.$route.query, { tenantId: this.tenantId, userId: this.userId });
        },
        
        // 根据当前菜单动态生成问题列表
        getDynamicQuelist() {
            if (this.menu === '大气') {
                return [
                    '本月该基地各大棚内最高/最低/平均气温是多少',
                    '该基地各大棚历史最高/最低/平均气温是多少？',
                    '今日大气环境如何？',
                    '最近一周的农事活动有哪些？',
                    '目前各大棚草莓处于哪种生长时期？有何特点及注意事项？',
                    '未来三天天气如何？有需要特别注意事项吗？',
                    '草莓病虫害有哪些？有什么特点及防治措施？',
                    '赣南龙莓对比普通白（红）有什么特点或优点？',
                    '赣南龙莓种植管理要求及标准是什么？',
                    '红蜘蛛虫害有什么特点及防治措施？',
                    '炭疽病有什么特点及防治措施？'
                ]
            } else if (this.menu === '土壤') {
                return [
                    '本月该基地各大棚土壤PH值最高/最低/平均值是多少？',
                    '该基地历史土壤PH值最高/最低/平均值是多少？',
                    '今日该基地各大棚土壤含水率是多少？需要浇水吗？',
                    '今日土壤环境如何？',
                    '最近一周的农事活动有哪些？',
                    '目前各大棚草莓处于哪种生长时期？有何特点及注意事项？',
                    '未来三天天气如何？有需要特别注意事项吗？',
                    '草莓病虫害有哪些？有什么特点及防治措施？',
                    '赣南龙莓对比普通白（红）有什么特点或优点？',
                    '赣南龙莓种植管理要求及标准是什么？',
                    '红蜘蛛虫害有什么特点及防治措施？',
                    '炭疽病有什么特点及防治措施？'
                ]
            } else {
                return []
            }
        },
        

        // 获取视频监控数据
        getMonitorData() {
            // 先获取用户绑定的大棚列表
            getUserGreenhouseList().then(userRes => {
                if (userRes.data && userRes.data.length > 0) {
                    // 提取用户绑定的大棚ID列表
                    const userGreenhouseIds = userRes.data.map(greenhouse => greenhouse.id);
                    
                    // 然后获取所有监控视频数据
                    getMonitorList().then(monitorRes => {
                        if (monitorRes.code === 200 && monitorRes.data && monitorRes.data.list) {
                            // 按大棚名称分类视频数据，只显示用户绑定的大棚
                            const groupedCameras = {};
                            monitorRes.data.list.forEach(monitor => {
                                // 检查监控是否属于用户绑定的大棚
                                if (userGreenhouseIds.includes(monitor.greenhouseId)) {
                                    const greenhouseName = monitor.greenhouseName;
                                    if (!groupedCameras[greenhouseName]) {
                                        groupedCameras[greenhouseName] = [];
                                    }
                                    groupedCameras[greenhouseName].push({
                                        monitorName: monitor.monitorName,
                                        monitorUrl: monitor.monitorUrl
                                    });
                                }
                            });
                            this.cameralist = groupedCameras;
                            
                            // 设置监控大棚列表和默认选中
                            this.cameraGreenhouseList = Object.keys(groupedCameras);
                            if (this.cameraGreenhouseList.length > 0) {
                                this.selectedCameraGreenhouse = this.cameraGreenhouseList[0];
                            }
                            
                            console.log('用户绑定的视频监控数据:', this.cameralist);
                        } else {
                            this.$message.error('获取视频监控数据失败');
                        }
                    }).catch(error => {
                        console.error('获取视频监控数据失败:', error);
                        this.$message.error('获取视频监控数据失败');
                    });
                } else {
                    this.$message.error('获取用户绑定大棚失败');
                }
            }).catch(error => {
                console.error('获取用户绑定大棚失败:', error);
                this.$message.error('获取用户绑定大棚失败');
            });
        },
        
        // 监控大棚选择变化
        handleCameraGreenhouseChange(greenhouseName) {
            this.selectedCameraGreenhouse = greenhouseName;
        },
        createtalk() {
            const that = this;
            that.talklist = []
            that.talkguanlianid = ''
            that.isfirst = true
            that.workflowSteps = [] // 清空工作流步骤数据
            // })
        },
        gocreatque(text, type) {
            console.log(text, type)
            this.sendmes(text)

            this.talkitem = this.talkitem == type ? '' : type
        },
        clickallap() {
            this.allspflag = !this.allspflag;
        },
        menuchange(e) {
            if (e == '设备') {
                this.$message.error('功能正在开发')
                return;
            }
            this.menu = e
            this.sbname = e == '大气' ? '大气环境监测传感器' : '土壤'
            this.isfirst = true
            this.talklist = []
            
            // 更新问题列表
            this.quelist = this.getDynamicQuelist()
            
            if (e === '视频') {
                // 切换到视频菜单时获取视频监控数据
                this.getMonitorData()
            } else {
                setTimeout(() => {
                    this.loadDeviceClassifyList(this.greenhouseList[0].id)
                }, 200);
            }
        },
        sbtypechange() {
            this.getshebeidatalist()
        },
        
        // 加载大棚列表
        loadGreenhouseList() {
            getGreenhouseList().then(res => {
                if (res.data && res.data.length > 0) {
                    this.greenhouseList = res.data
                    // 默认选择第一个大棚
                    this.selectedGreenhouseId = res.data[0].id
                    // 加载该大棚的设备类型列表
                    this.loadDeviceClassifyList(res.data[0].id)
                }
            }).catch(error => {
                console.error('获取大棚列表失败:', error)
            })
        },
        
        // 大棚选择变化
        handleGreenhouseChange(greenhouseId) {
            if (greenhouseId) {
                this.loadDeviceClassifyList(greenhouseId)
            }
        },
        
        // 加载设备类型列表
        loadDeviceClassifyList(greenhouseId) {
            getDeviceClassifyList(greenhouseId).then(res => {
                if (res.data && res.data.length > 0) {
                    
                    const newlist = []
                    res.data.forEach(item => {
                        if (this.menu == '大气') {
                            if (item.classifyName.includes('土壤')) return
                            newlist.push(item)
                        } else {
                            if (!item.classifyName.includes('土壤')) return
                            newlist.push(item)
                        }
                         
                        
                    })
                    // 默认选择第一个设备类型
                    this.deviceClassifyList = newlist
                    this.selectedDeviceClassify = newlist[0].classifyName
                    // 根据设备类型查询设备数据
                    this.getDeviceDataByClassify(newlist[0].classifyName)
                } else {
                    this.deviceClassifyList = []
                    this.selectedDeviceClassify = ''
                }
            }).catch(error => {
                console.error('获取设备类型列表失败:', error)
            })
        },
        
        // 设备类型选择变化
        handleDeviceClassifyChange(deviceClassifyName) {
            if (deviceClassifyName) {
                this.getDeviceDataByClassify(deviceClassifyName)
            }
        },
        
        // 根据设备类型获取设备数据
        getDeviceDataByClassify(deviceClassifyName) {
            // 这里需要根据具体的设备类型ID调用相应的设备数据接口
            // 暂时保持现有的设备数据获取逻辑
            console.log('根据设备类型获取数据:', deviceClassifyName)
            this.getshebeidatalist() // 可以调用现有的设备数据获取方法
        },
        handleFileChange(event) {
            const file = event.target.files[0]; // 获取选中的文件
            // 处理文件上传的逻辑...
            this.$message.info('图片正在上传..')
            const xhr = new XMLHttpRequest();
            const formdata = new FormData();
            formdata.append('file', file)
            xhr.open('POST', baseUrl + '/queapi/file/oss', true);
            xhr.send(formdata);
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    const res = JSON.parse(xhr.responseText);
                    this.talkimgurl = res.message
                    this.$message.success('上传成功')
                    console.log(res.message)
                }
            }
        },
        getshebeidatalist(e) {
            // 获取当前选择的大棚名称
            const selectedGreenhouse = this.greenhouseList.find(g => g.id === this.selectedGreenhouseId);
            const greenhouseName = selectedGreenhouse ? selectedGreenhouse.serialNumber : '';
            
            const param = `greenhouse=${encodeURIComponent(greenhouseName)}&device_type=${encodeURIComponent(this.selectedDeviceClassify)}&type=${encodeURIComponent(this.selectedDeviceClassify == '棚外气象站' ? '气象' : this.menu)}`
            getsbdatalist(param).then(res => {
                if (e) {
                    this.$message.success('数据已更新')
                }
                console.log(res)
                // if (this.valuelist.length > 0) {
                //     this.$message.success('数据已刷新')
                // }
                const newdata = []
                  this.valuelist = res.data
                // if (this.menu == '大气') {
                //     this.valuelist = res.data
                // } else {
                //     const sblist = []
                //     res.data.forEach(item => {
                //         if (!sblist.includes(item.deviceName.substr(0, item.deviceName.indexOf('排')))) {
                //             sblist.push(item.deviceName.substr(0, item.deviceName.indexOf('排')))
                //         }
                //     })

                //     res.data.forEach(sitem => {
                //         sblist.forEach(item => {
                //             if (sitem.deviceName.substr(0, sitem.deviceName.indexOf('排')) == item) {
                //                 const itemed = newdata.filter(s => s.deviceName == item + "排土壤传感器")
                //                 if (itemed[0]) {
                //                     if (sitem.conductivity) {
                //                         itemed[0].conductivity = sitem.conductivity
                //                     } if (sitem.nitrogen) {
                //                         itemed[0].nitrogen = sitem.nitrogen
                //                     } if (sitem.phosphorus) {
                //                         itemed[0].phosphorus = sitem.phosphorus
                //                     } if (sitem.potassium) {
                //                         itemed[0].potassium = sitem.potassium
                //                     } if (sitem.ph) {
                //                         itemed[0].ph = sitem.ph
                //                     } if (sitem.temp) {
                //                         itemed[0].temp = sitem.temp
                //                     } if (sitem.water) {
                //                         itemed[0].water = sitem.water
                //                     }
                //                 } else {
                //                     newdata.push({
                //                         conductivity: sitem.conductivity,
                //                         createTime: sitem.createTime,
                //                         deviceName: item + "排土壤传感器",
                //                         id: 7,
                //                         nitrogen: sitem.nitrogen,
                //                         ph: sitem.ph,
                //                         phosphorus: sitem.phosphorus,
                //                         potassium: sitem.potassium,
                //                         sensorId: 4,
                //                         temp: sitem.temp,
                //                         time: sitem.time,
                //                         updateTime: sitem.time,
                //                         water: sitem.water
                //                     })
                //                 }


                //             }
                //         })

                //     })
                //     this.valuelist = newdata
                // }

            })
        },
        getshebeilist() {
            getbcmsblist(this.menu).then(res => {
                console.log(res)
                this.sblist = res.data
                this.sbname = this.menu == '大气' ? res.data[0] : '土壤'
                setTimeout(() => {
                    this.getshebeidatalist()
                }, 200);
            })
        },
        opensd() {
            this.issd = !this.issd
        },
        sendmes(msg) {
            this.isfirst = false
            document.getElementById('qmess').value = msg
            setTimeout(() => {
                this.senmessage()
            }, 200);
        },
        triggerUpload() {
            this.$refs.fileInput.click(); // 触发input的点击事件
        },
        senmessage() {
            let message = document.getElementById('qmess').value
            if (message == '' && this.talkimgurl) {
                message = '帮我分析一下这张图片'
            }
            if (message == '' || this.isconn) return;
            
            // 重置echarts状态，避免影响后续问题
            this.echartsOutputStatus = 0;
            
            this.talklist.push({
                message: message,
                talkimgurl: this.talkimgurl,
                reply_content: {
                    result1: '', // 图表前的内容
                    result2: '', // 图表后的内容
                }
            })
            const element = document.getElementById('resultbox')
            setTimeout(() => {
                element.scrollTo({
                    x: 0,
                    top: element.scrollHeight,
                    behavior: 'smooth'
                })

                document.getElementById('qmess').value = ''
            }, 300)
            message = message.includes('温度横向对比查看') ? (this.menu === '大气' ? '空气' : '土壤') + message : message
            this.connectSever(message);
        },

        connectSever(message) {
            const that = this;
            const modeltype = this.issd ? 'deepseek-r1:70b' : 'qwen2-72b';
            that.eventSource = new EventSource(encodeURI(`${baseUrl}/queapi/dify/dify_talk?query=${message}&userId=${that.userId}&module=1&tenantId=${that.tenantId}`, {}))
            that.isconn = true;
            
            // 简化echarts处理逻辑 - 只负责数据存储
            let echartscode = ''; // echarts代码内容
            
            // 工作流数据
            const workflowData = {
                userInput: '',
                workflowSteps: [],
                totalTime: 0,
                nodeStartTimes: {} // 存储节点开始时间戳
            };
            
            that.eventSource.addEventListener('open', (event) => {
                that.isconn = true;
                console.log('连接已建立', JSON.stringify(event))

            })
            let thinkend = 0;
            let returncontent = ''
            let endflag = false
            const lnum = this.talklist.length - 1
            that.eventSource.onmessage = (event) => {
                that.isstop = true;
                
                // console.log(event.data)
                const data = JSON.parse(event.data)
                
                // 处理工作流事件
                if (data.event && data.event !== 'message') {
                    // console.log('工作流事件:', data.event, data.data);
                    
                    // 统计工作流信息
                    if (data.event === 'workflow_started' && data.data?.inputs?.sys?.query) {
                        workflowData.userInput = data.data.inputs.sys.query;
                        // console.log('工作流开始 - 用户输入:', workflowData.userInput);
                    }
                    
                    if (data.event === 'node_started' && data.data) {
                        // console.log('节点开始 - 步骤:', data.data.title);
                        
                        // 判断步骤名称，如果是"查询变量名称"则直接return
                        if (data.data.title === '查询变量名称') {
                            return;
                        }
                        
                        // 确保工作流数据已初始化
                        if (!that.talklist[lnum].reply_content.workflowData) {
                            Vue.set(that.talklist[lnum].reply_content, 'workflowData', {
                                userInput: '',
                                workflowSteps: [],
                                totalTime: 0,
                                nodeStartTimes: {}
                            });
                        }
                        
                        // 检查是否有未完成的上一个步骤
                        this.checkAndCompletePreviousSteps(data.data.title, that.talklist[lnum].reply_content.workflowData);
                        
                        // 节点开始时添加loading状态
                        this.addWorkflowStepToDisplay(data.data.title, 'loading');
                        
                        // 记录节点开始时间戳
                        that.talklist[lnum].reply_content.workflowData.nodeStartTimes[data.data.title] = Date.now();
                    }
                    
                    if (data.event === 'node_finished' && data.data) {
                        // 判断步骤名称，如果是"查询变量名称"则直接return
                        if (data.data.title === '查询变量名称') {
                            return;
                        }
                        
                        // 确保工作流数据已初始化
                        if (!that.talklist[lnum].reply_content.workflowData) {
                            Vue.set(that.talklist[lnum].reply_content, 'workflowData', {
                                userInput: '',
                                workflowSteps: [],
                                totalTime: 0,
                                nodeStartTimes: {}
                            });
                        }
                        
                        // 智能计算耗时：如果有结束时间就用时间字段，否则根据时间戳计算
                        let elapsedTime = data.data.elapsed_time || 0;
                        
                        if (!elapsedTime && that.talklist[lnum].reply_content.workflowData.nodeStartTimes[data.data.title]) {
                            // 如果没有结束时间，根据开始时间戳和当前时间计算
                            const startTime = that.talklist[lnum].reply_content.workflowData.nodeStartTimes[data.data.title];
                            const currentTime = Date.now();
                            elapsedTime = (currentTime - startTime) / 1000; // 转换为秒
                            console.log(`节点 ${data.data.title} 无结束时间，根据时间戳计算耗时: ${elapsedTime.toFixed(2)}秒`);
                        }
                        
                        // 累计总时间
                        if (elapsedTime > 0) {
                            that.talklist[lnum].reply_content.workflowData.totalTime += elapsedTime;
                        }
                        
                        // console.log('节点完成 - 步骤:', data.data.title, '耗时:', elapsedTime);
                        
                        // 节点完成时更新步骤显示（从loading状态更新为completed）
                        this.updateWorkflowStepDisplay(data.data.title, elapsedTime);
                        
                        // 清理开始时间记录
                        delete that.talklist[lnum].reply_content.workflowData.nodeStartTimes[data.data.title];
                    }
                    
                    // 处理node_finished事件中的echarts
                    if (data.event === 'node_finished' && data.data?.outputs?.text?.includes('```echarts')) {
                        const text = data.data.outputs.text;
                        
                        // 查找```echarts和```之间的内容
                        const echartsStart = text.indexOf('```echarts');
                        if (echartsStart !== -1) {
                            const start = text.indexOf('\n', echartsStart) + 1;
                            const end = text.indexOf('\n```', start);
                            
                            if (start !== -1 && end !== -1) {
                                const echartsJson = text.substring(start, end).trim();
                                // console.log('提取到的echarts JSON:', echartsJson);
                                
                                try {
                                    // 将字符串转换为JSON对象
                                    const echartsConfig = JSON.parse(echartsJson);
                                    
                                    // 将处理后的echarts代码存储到reply_content中
                                    Vue.set(that.talklist[lnum].reply_content, 'echartsCharts', [{
                                        options: echartsConfig,
                                        loading: false
                                    }]);
                                    
                                    console.log('成功设置echarts配置');
                                    
                                    // 移除result1中的echarts代码块，防止代码暴露
                                    if (that.talklist[lnum].reply_content.result1.includes('```echarts')) {
                                        const result1 = that.talklist[lnum].reply_content.result1;
                                        const codeStart = result1.indexOf('```echarts');
                                        const codeEnd = result1.indexOf('\n```', codeStart) + 4;
                                        
                                        if (codeStart !== -1 && codeEnd !== -1) {
                                            that.talklist[lnum].reply_content.result1 = 
                                                result1.substring(0, codeStart) + 
                                                result1.substring(codeEnd);
                                        }
                                    }
                                    
                                } catch (error) {
                                    console.error('解析echarts JSON失败:', error);
                                    // 解析失败时取消loading状态并隐藏echarts DOM
                                    if (that.talklist[lnum].reply_content.echartsCharts) {
                                        that.talklist[lnum].reply_content.echartsCharts.forEach(chart => {
                                            chart.loading = false;
                                        });
                                        // 移除echartsCharts数组，隐藏echarts DOM
                                        Vue.set(that.talklist[lnum].reply_content, 'echartsCharts', []);
                                    }
                                    
                                    // 移除result1中的echarts代码块，防止代码暴露
                                    if (that.talklist[lnum].reply_content.result1.includes('```echarts')) {
                                        const result1 = that.talklist[lnum].reply_content.result1;
                                        const codeStart = result1.indexOf('```echarts');
                                        const codeEnd = result1.indexOf('\n```', codeStart) + 4;
                                        
                                        if (codeStart !== -1 && codeEnd !== -1) {
                                            that.talklist[lnum].reply_content.result1 = 
                                                result1.substring(0, codeStart) + 
                                                result1.substring(codeEnd);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    return;
                }
                
               

                // console.log('dddddd', that.talklist[lnum])
                if (!data) {
                    that.talklist[lnum].reply_content.result1 = '正在思考...'
                    that.talklist[lnum].reply_content.thinktxt = ''
                    return
                }
                if (that.talklist[lnum].reply_content.result1 == '正在思考...') {
                    that.talklist[lnum].reply_content.result1 = ''
                    that.talklist[lnum].reply_content.result2 = ''
                }
                if (data.id) {
                    this.historyid = data.id
                    this.talkguanlianid = data.id
                }

                that.isshowcw = true
                if (data.answer) {
            
                    // 使用正则表达式替换所有以#开头的标题标记
                    data.answer = data.answer.replace(/^#+\s*/gm, '')
                }
                if (data.answer == '[DONE]') {
                    that.talklist[lnum].reply_content.relatedquestion = data.relatedquestion;
                    // console.log('输出结束', that.talklist[lnum].reply_content, echartscode)
                    return;
                }
                
                // 检查当前接收的数据中是否包含```echarts
                if (that.talklist[lnum].reply_content.result1.includes('```echarts') && that.echartsOutputStatus === 0) {
                    // 如果有，用状态保存为echarts输出状态为1
                    that.echartsOutputStatus = 1;
                    // Vue.set(that, 'echartsOutputStatus', 1);
                    echartscode = data.answer; // 将当前数据也包含进去
                    console.log('开始echarts块', data.answer);
                    
                    // 设置echarts图表加载状态
                    if (!that.talklist[lnum].reply_content.echartsCharts) {
                        Vue.set(that.talklist[lnum].reply_content, 'echartsCharts', [{
                            loading: true,
                            loadingText: '图表正在加载'
                        }]);
                    } else {
                        that.talklist[lnum].reply_content.echartsCharts.forEach(chart => {
                            chart.loading = true;
                            chart.loadingText = '图表正在加载';
                        });
                    }
                }
                
                // 根据echarts输出状态处理数据
                if (that.echartsOutputStatus === 1) {
                    echartscode += data.answer;
                    // 判断echartscode里面是不是包含```（结束标记）
                    if (echartscode.includes('```')) {
                        // 如果包含，就将echarts输出状态设置为2
                        that.echartsOutputStatus = 2;
                        // Vue.set(that, 'echartsOutputStatus', 2);
                    }
                    console.log('echats', echartscode)
                } else if (that.echartsOutputStatus === 2) { 
                    Vue.set(that.talklist[lnum].reply_content, 'result2', (that.talklist[lnum].reply_content.result2 + data.answer).replace('undefined', ''))
                } else  {
                    // 不在echarts块中，正常处理内容
                    if (thinkend == 1 && this.issd) {
                        Vue.set(that.talklist[lnum].reply_content, 'thinktxt', (that.talklist[lnum].reply_content.thinktxt + data.answer).replace('undefined', ''))
                    } else {
                        Vue.set(that.talklist[lnum].reply_content, 'result1', (that.talklist[lnum].reply_content.result1 + data.answer).replace('undefined', ''))
                    }
                }
                
                // console.log(that.talklist[lnum].reply_content.thinktxt)
                this.$forceUpdate();
                if (that.talklist[lnum].reply_content.result1.length % 10 == 0 || event.data.includes('，')) {
                    that.$nextTick(() => {
                        const element = document.getElementById('resultbox')
                        element.scrollTo({
                            x: 0,
                            top: Number.MAX_SAFE_INTEGER,
                            behavior: 'smooth'
                        })
                    })
                }
            }
            that.eventSource.onerror = (event) => {
                
                that.isconn = false;
                that.talkimgurl = ''
                that.eventSource.close()
                that.eventSource = null
                if (that.talklist[lnum].reply_content.imagereplys) {
                    that.talklist[lnum].reply_content.imagereplys.forEach(item => {
                        that.srcList.push(item.replace('http://47.96.179.72:11454/', 'http://strawberryai.web.shuzhiren.com/klgapi/'))
                    })
                    // that.srcList.push(...that.talklist[that.talklist.length - 1].reply_content.resultimgs)
                }
                that.$nextTick(() => {
                    const element = document.getElementById('resultbox')
                    element.scrollTo({
                        x: 0,
                        top: Number.MAX_SAFE_INTEGER,
                        behavior: 'smooth'
                    })
                })
            }
        },
        stopconn() {
            this.eventSource.close()
            this.eventSource = null
            this.isconn = false;
            window.localStorage.setItem('talklist', JSON.stringify(this.talklist))
            this.$emit('endtalk')
        },
        
        generateWorkflowInfo(workflowData) {
            let workflowInfo = '#### 📊 工作流执行报告\n\n';
            
            // 用户输入
            if (workflowData.userInput) {
                workflowInfo += `**用户输入：** ${workflowData.userInput}\n\n`;
            }
            
            // 工作流步骤
            if (workflowData.workflowSteps.length > 0) {
                workflowInfo += '**执行步骤：**\n';
                workflowData.workflowSteps.forEach((step, index) => {
                    const statusIcon = step.status === 'succeeded' ? '✅' : '⏳';
                    workflowInfo += `${index + 1}. ${statusIcon} ${step.title} - ${step.elapsedTime.toFixed(2)}秒\n`;
                });
                workflowInfo += '\n';
            }
            
            // 总耗时
            if (workflowData.totalTime > 0) {
                workflowInfo += `**总耗时：** ${workflowData.totalTime.toFixed(2)}秒\n\n`;
            }
            
            workflowInfo += '---\n\n';
            return workflowInfo;
        },
        
        addWorkflowStepToDisplay(title, status) {
            const stepId = 'step-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
            const lnum = this.talklist.length - 1;
            
            if (lnum >= 0) {
                // 确保工作流数据已初始化
                if (!this.talklist[lnum].reply_content.workflowData) {
                    Vue.set(this.talklist[lnum].reply_content, 'workflowData', {
                        userInput: '',
                        workflowSteps: [],
                        totalTime: 0,
                        nodeStartTimes: {}
                    });
                }
                
                if (status === 'loading') {
                    this.talklist[lnum].reply_content.workflowData.workflowSteps.push({
                        id: stepId,
                        title: title,
                        status: 'loading',
                        elapsedTime: 0
                    });
                } else {
                    this.talklist[lnum].reply_content.workflowData.workflowSteps.push({
                        id: stepId,
                        title: title,
                        status: 'completed',
                        elapsedTime: status
                    });
                }
            }
            
            // 滚动到最新内容
            this.$nextTick(() => {
                const element = document.getElementById('resultbox');
                if (element) {
                    element.scrollTo({
                        x: 0,
                        top: element.scrollHeight,
                        behavior: 'smooth'
                    });
                }
            });
            
            return stepId;
        },
        
        updateWorkflowStepDisplay(title, elapsedTime) {
            const lnum = this.talklist.length - 1;
            
            if (lnum >= 0 && this.talklist[lnum].reply_content.workflowData) {
                // 找到对应的步骤并更新状态
                for (let i = this.talklist[lnum].reply_content.workflowData.workflowSteps.length - 1; i >= 0; i--) {
                    if (this.talklist[lnum].reply_content.workflowData.workflowSteps[i].title === title && 
                        this.talklist[lnum].reply_content.workflowData.workflowSteps[i].status === 'loading') {
                        this.talklist[lnum].reply_content.workflowData.workflowSteps[i].status = 'completed';
                        this.talklist[lnum].reply_content.workflowData.workflowSteps[i].elapsedTime = elapsedTime;
                        // 使用Vue.set确保响应式更新
                        Vue.set(this.talklist[lnum].reply_content.workflowData.workflowSteps, i, 
                            {...this.talklist[lnum].reply_content.workflowData.workflowSteps[i]});
                        break;
                    }
                }
            }
        },
        
        checkAndCompletePreviousSteps(currentTitle, workflowData) {
            // 检查是否有处于loading状态的步骤，如果有则自动完成它们
            if (workflowData && workflowData.workflowSteps) {
                for (let i = 0; i < workflowData.workflowSteps.length; i++) {
                    const step = workflowData.workflowSteps[i];
                    if (step.status === 'loading' && step.title !== currentTitle) {
                        // 计算这个步骤的耗时（从开始时间到当前时间）
                        const startTime = workflowData.nodeStartTimes[step.title];
                        let elapsedTime = 0;
                        
                        if (startTime) {
                            elapsedTime = (Date.now() - startTime) / 1000;
                            console.log(`自动完成步骤 ${step.title}，耗时: ${elapsedTime.toFixed(2)}秒`);
                        }
                        
                        // 更新步骤状态为completed
                        step.status = 'completed';
                        step.elapsedTime = elapsedTime;
                        
                        // 累计总时间
                        if (elapsedTime > 0) {
                            workflowData.totalTime += elapsedTime;
                        }
                        
                        // 清理开始时间记录
                        delete workflowData.nodeStartTimes[step.title];
                        
                        // 使用Vue.set确保响应式更新
                        Vue.set(workflowData.workflowSteps, i, {...step});
                    }
                }
            }
        }
        
    }
}




</script>

<style scoped lang="less">
h1{
    font-size: 16px !important;
}
.datamain {
    width: 100%;
    height: 100%;
    position: relative;
    background-image: url('../assets/img/bg.png');
    background-size: 100% 100%;

    .topbox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #F6F6F6;
        padding: 12px;

        .menuitem {
            font-size: 14px;
            color: #494949;

            span {
                padding: 8px 10px;
                border-radius: 8px;
                background-color: #15d200;
                color: #fff;
                font-size: 12px;
            }
        }

        .med {
            color: #000000d1;
            font-size: 18px;
            position: relative;
        }
        .med::after{
            background: linear-gradient( 352deg, #ffaac000 0%, #D94E6B 100%);
            border-radius: 6px;
            content: '';
            width: 35px;
            height: 10px;
            position: absolute;
            bottom: -4px;
            left: 0;
        }
    }

    .contentbox {
        width: calc(100% - 0px);
        height: calc(100% + 10px);
        padding: 10px;
        display: flex;
        flex-wrap: wrap;
        position: relative;

        .leftbox {
            width: 50px;
            background: #e2ebf5c2;
            border-radius: 10px;
            border: 1px solid #ffffff90;
            height: calc(100% - 60px);
            display: flex;
            flex-wrap: wrap;
            align-content: space-around;

            .menuitem {
                width: 100%;
                padding-top: 10px;
                color: #333C4C60;
                margin-bottom: 20px;

                .icon {
                    width: 100%;
                    text-align: center;

                    img {
                        width: 20px;
                    }
                }

                .name {
                    margin-top: 5px;
                    width: 100%;
                    text-align: center;
                    font-size: 14px;

                }
            }

            .med {
                color: #3D57A4;
            }
        }

        .lefthide {
            width: 50px;
            background: #e2ebf5c2;
            border-radius: 10px;
            border: 1px solid #ffffff90;
            height: 165px;
            display: flex;
            flex-wrap: wrap;
            align-content: space-around;

            .menuitem {
                width: 100%;
                color: #333C4C60;

                .icon {
                    width: 100%;
                    text-align: center;

                    img {
                        width: 20px;
                    }
                }

                .name {
                    width: 100%;
                    text-align: center;
                    font-size: 14px;

                }
            }

            .med {
                color: #3D57A4;
            }
        }
        .videobox{
            width: calc(100% - 70px);
            margin-left:15px;
            height:100%;
            overflow-y: auto;
            padding: 0px;
            
            .camera-selector {
                margin-bottom: 20px;
                padding: 0 10px;
                
                /deep/ .el-select {
                    width: 200px;
                }
            }
            
            .monitor-container {
                margin-bottom: 30px;
                
                .greenhouse-title {
                    margin-bottom: 15px;
                    padding-bottom: 10px;
                    border-bottom: 2px solid #e0e0e0;
                    
                    h3 {
                        margin: 0;
                        font-size: 18px;
                        color: #333;
                        font-weight: bold;
                    }
                }
                
                .monitor-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                    gap: 20px;
                    
                    .monitor-item {
                        background: #fff;
                        border-radius: 8px;
                        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                        overflow: hidden;
                        
                        .monitor-name {
                            padding: 12px;
                            background: #f5f5f5;
                            font-size: 14px;
                            color: #666;
                            text-align: center;
                            border-bottom: 1px solid #e0e0e0;
                        }
                        
                        .monitor-iframe {
                            width: 100%;
                            height: 200px;
                            border: none;
                        }
                    }
                }
            }
            
            .no-data {
                text-align: center;
                padding: 40px;
                color: #999;
                font-size: 16px;
            }
        }
        .rightbox {
            width: calc(100% - 60px);
            margin-left: 10px;
            height: 170px;
            border-radius: 10px;

            .databox {
                height: 164px;
                border-radius: 10px;
                border: 1px solid #ffffff90;
                padding: 5px 12px;
                position: relative;

                .refbox {
                    position: absolute;
                    right: 10px;
                    font-size: 18px;
                    color: #1d9bcf;
                    top: 6px;
                    cursor: pointer;
                    z-index: 9
                }

                .selectbox {
                    width: 120px;
                    position: absolute;
                    right: 5px;
                    top: 5px;
                    z-index: 3;
                }

                /deep/ .el-carousel__container {
                    height: 100%;
                }

                /deep/ .el-carousel__indicators--horizontal {
                    display: none;
                }

                /deep/ .el-carousel__arrow--left {
                    left: 0px;
                }

                /deep/ .el-carousel__arrow--right {
                    right: 0px;
                }

                .uptime {
                    width: 100%;
                    font-size: 12px;
                    padding-top: 10px;
                    color: #00041F70;
                    text-align: right;
                }

                .titname {
                    text-align: left;
                    font-size: 16px;
                    color: #6D9E45;
                    margin: 10px 0;
                    margin-top: 0;
                }

                .valuebox {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;

                    span {
                        font-size: 12px;
                        color: #95671f;
                    }

                    .valueitem {
                        width: calc(20% - 5px);
                        text-align: center;
                        background-color: #E8F1FF;
                        border-radius: 10px;
                        border: 1px solid #ffffff80;

                        .name,
                        .unit {
                            text-align: center;
                            font-size: 14px;
                            color: #333;
                            margin: 10px 0;
                        }

                        .value {
                            font-size: 16px;
                            color: #6D9E45;

                        }
                    }
                }

                .valuebox_t {
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    flex-wrap: wrap;
                    color: #95671f;


                    .valueitem {
                        width: calc(25% - 5px);
                        margin: 5px 2px;
                        padding: 2px 5px;
                        text-align: center;
                        background-color: #E8F1FF;
                        border-radius: 10px;
                        border: 1px solid #ffffff80;

                        .name {
                            text-align: center;
                            font-size: 14px;
                            color: #333;
                            margin: 5px 0;
                        }

                        .value {
                            font-size: 14px;
                            color: #95671f;

                            span {
                                font-size: 10px;
                                color: 95671f;
                            }


                        }
                    }
                }
            }


        }

        .talkbox {
            width: calc(100% - 80px);
            height: calc(100% - 252px);
            border-radius: 10px;
            border: 1px solid #ffffff90;
            margin-top: 10px;
            background: linear-gradient(180deg, #B0D393 0%, rgba(178, 212, 153, 0.01) 100%);
            position: absolute;
            right: 10px;
            bottom: 70px;


            .talktitle {
                font-size: 16px;
                color: #00000060;
                width: 100%;
                padding: 12px;
                text-align: center;
                border-bottom: 1px dashed #00000060;
                position: relative;

                .allap {
                    position: absolute;
                    left: 10px;
                    top: 10px;
                    font-size: 20px;
                    color: #0066ff;
                }
            }

            .content {
                width: 100%;
                height: calc(100% - 45px);
                overflow-y: auto;

                .custom-markdown {
                    width: 100%;
                    height: 100%;
                    font-size: 14px;
                    overflow-y: auto;
                    // line-height: 22px !important;
                    word-break: break-all;
                    h1{
                        font-size: 16px !important;
                    }
                }

                .custom-markdown {
                    h1{
                        font-size: 16px !important;
                    }
                    /deep/ .table {
                        border-collapse: collapse;
                        border-spacing: 0;
                    }
                    /deep/ .h1, /deep/ h2{
                        font-size: 14px !important;
                    }
                    /deep/ .table {
                        border-top: 1px solid #333;
                        border-left: 1px solid #333;
                    }

                    /deep/ .table tbody tr td,
                    /deep/ .table thead tr th {
                        border-right: 1px solid #333;
                        border-bottom: 1px solid #333;
                        padding: 6px;
                    }
                }

                .xmindbox {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;

                    img {
                        width: 100%;
                    }
                }

                .zhuibox {
                    .question-carousel {
                        overflow: hidden;
                        /deep/ .el-carousel__container {
                            height: auto;
                            min-height: 300px;
                        }
                        
                        /deep/ .el-carousel__indicators {
                            bottom: -20px;
                        }
                        
                        /deep/ .el-carousel__arrow {
                            background-color: rgba(255, 255, 255, 0.7);
                            color: #3D57A4;
                            
                            &:hover {
                                background-color: #3D57A4;
                                color: #fff;
                            }
                        }
                        
                        /deep/ .el-carousel__item {
                            display: flex;
                            flex-direction: column;
                            justify-content: flex-start;
                            align-items: center;
                            padding: 10px 0;
                        }
                    }
                    
                    .zhuiitem {
                        display: flex;
                        align-items: center;
                        padding: 10px;
                        margin: 5px 10px;
                        background-color: #1C223610;
                        font-size: 14px;
                        border-radius: 10px;
                        cursor: pointer;
                        color: #00000090;
                        width: calc(100% - 20px);
                        box-sizing: border-box;
                        transition: all 0.3s ease;

                        &:hover {
                            background-color: #3D57A4;
                            color: #fff;
                            transform: translateY(-2px);
                        }

                        img {
                            width: 20px;
                            margin-right: 12px;
                        }
                    }
                }

                .aiitem {
                    display: flex;
                    width: calc(100% + 0px);
                    position: relative;
                    margin: 5px 0;
                    flex-wrap: wrap;

                    .aileft {
                        padding: 10px 0;

                        img {
                            height: 40px;
                            margin-left: 10px;
                        }
                    }

                    .airight {
                        min-width: 180px;
                        max-width: calc(100% - 70px);
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        padding-left: 10px;
                        text-align: left;
                        margin-bottom: 10px;
                        background: #ffffff70;

                        border-radius: 0px 12px 12px 12px;
                        position: relative;

                        /* 工作流步骤样式 */
                        .working {
                            width: 100%;
                            margin: 0 auto 10px;
                           
                            padding: 4px 10px;
                            backdrop-filter: blur(10px);
                        }

                        .workflow-step {
                            margin: 2px 0;
                            animation: slideIn 0.4s ease-out;
                            transition: all 0.3s ease;
                        }

                        .workflow-step:last-child {
                            margin-bottom: 0;
                        }

                        .step-content {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 4px 6px;
                            background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(245, 247, 255, 0.9) 100%);
                            border-radius: 8px;
                            border: 1px solid rgba(61, 87, 164, 0.1);
                            box-shadow: 0 1px 4px rgba(61, 87, 164, 0.05);
                            transition: all 0.3s ease;
                        }

                        .step-content:hover {
                            transform: translateY(-1px);
                            box-shadow: 0 4px 12px rgba(61, 87, 164, 0.1);
                        }

                        .step-info {
                            display: flex;
                            align-items: center;
                            gap: 5px;
                        }

                        .step-icon {
                            width: 15px;
                            height: 15px;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 7px;
                            transition: all 0.3s ease;
                        }

                        .step-icon.loading {
                            background: linear-gradient(135deg, #ffd700, #ffa500);
                            animation: pulse 1.5s ease-in-out infinite;
                            color: #fff;
                        }

                        .step-icon.completed {
                            background: linear-gradient(135deg, #4CAF50, #45a049);
                            color: #fff;
                        }

                        .step-title {
                            font-size: 13px;
                            color: #2c3e50;
                            font-weight: 600;
                            letter-spacing: 0.3px;
                        }

                        .step-time {
                            font-size: 12px;
                            font-weight: 500;
                            padding: 4px 10px;
                            border-radius: 16px;
                            transition: all 0.3s ease;
                        }

                        .step-time.loading {
                            background: linear-gradient(135deg, #e3f2fd, #bbdefb);
                            color: #1976d2;
                            animation: pulse 2s ease-in-out infinite;
                        }

                        .step-time.completed {
                            background: linear-gradient(135deg, #e8f5e8, #c8e6c9);
                            color: #2e7d32;
                        }


                        .name {
                            font-size: 14px;
                            color: #333;
                            margin-bottom: 10px;

                            span {
                                font-size: 12px;
                                background: #F8F8F9;
                                border-radius: 6px;
                                padding: 4px 8px;
                                margin-left: 10px;
                            }
                        }

                        .aitext {
                            // width: 500px;
                            width: 100%;
                            color: #333;
                            padding: 10px;
                            font-size: 14px;

                            .loadinggif {
                                height: 52px;

                                img {
                                    height: 52px;
                                }
                            }

                            /deep/ .el-collapse-item__header,
                            /deep/ .el-collapse-item__wrap,
                            /deep/ .el-collapse-item__content {
                                background-color: #f2f2f2 !important;
                                font-size: 14px;
                                padding-bottom: 0;
                                line-height: 16px !important;

                            }

                            /deep/ .el-collapse-item__header {
                                color: #409eff
                            }

                            /deep/ .el-collapse-item__content {
                                color: #8b8b8b !important;
                                border-left: 1px solid #bdbdbd;
                                padding-left: 10px;
                            }

                            .resultbox {
                                color: #262626;
                                background-color: #ffffff70;
                                padding: 0 10px;
                                margin-bottom: 10px;
                                border-radius: 12px;
                            }

                            .custom-markdown code,
                            .custom-markdown /deep/ pre,
                            .custom-markdown pre code {
                                white-space: break-spaces;
                                word-break: break-all;
                                font-size: 14px;

                                /* 换行 */
                            }


                        }


                    }
                    

                }

                .useritem {
                    position: relative;
                    color: #333;
                    width: calc(100% - 10px);
                    display: flex;
                    justify-content: flex-start;
                    flex-direction: row-reverse;

                    .userleft {
                        padding: 10px 0;

                        img {
                            width: 30px;
                        }
                    }

                    .userright {
                        // background: #FF009D;
                        padding-right: 3px;
                        text-align: left;
                        float: right;
                        margin: 10px 0;
                        max-width: 800px;
                        margin-left: 40px;

                        
                        .usertext {
                            background: #ffffff70;
                            color: #333;
                            border-radius: 12px 0px 12px 12px;
                            font-size: 14px;
                            line-height: 15px;
                            padding: 10px 20px;
                            white-space: pre-wrap;
                        }
                    }
                }


            }
        }

        .sendbox {
            width: 100%;
            height: 40px;
            display: flex;

            .photo {
                width: 40px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 20px;
                }
            }

            .inputbox {
                width: calc(100% - 10px);
                margin-left: 0px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
                display: flex;

                .talkimg {
                    padding: 5px;
                    position: relative;

                    .delbox {
                        position: absolute;
                        right: 0;
                        top: 0;
                        width: 15px;
                        height: 15px;
                        background-color: red;
                        color: #fff;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                    }

                    img {
                        width: 30px;
                    }
                }

                .delbtn {
                    position: absolute;
                    bottom: 4px;
                    right: 10px;
                    width: 30px;
                    height: 30px;
                    background: red;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 32px;
                    color: #fff;
                    border-radius: 50%;
                }

                input {
                    width: 100%;
                    height: 100%;
                    border: 0;
                    padding-left: 10px;
                }

                input:focus {
                    outline: none;
                    /* 去除默认的outline，如果想完全去除边框，可以设置border为none */
                    border: none;
                    /* 直接移除边框 */
                }
            }

            .btnbox {
                width: 40px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;

                img {
                    width: 30px;
                }
            }

            .skbtn {
                width: 50px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right:10px;
            }

            .skbtned {
                background-color: #3D57A4;
                color: #fff;
            }


        }

        .sendboxhide {
            width: calc(100% - 20px);
            height: 40px;
            display: flex
        ;
            position: absolute;
            right: 10px;
            bottom: 20px;

            .photo {
                width: 40px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 20px;
                }
            }

            .inputbox {
                width: calc(100% - 60px);
                margin-left: 10px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                overflow: hidden;
                position: relative;

                .delbtn {
                    position: absolute;
                    bottom: 4px;
                    right: 10px;
                    width: 30px;
                    height: 30px;
                    background: red;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 32px;
                    color: #fff;
                    border-radius: 50%;
                }

                input {
                    width: 100%;
                    height: 100%;
                    border: 0;
                    padding-left: 10px;
                }

                input:focus {
                    outline: none;
                    /* 去除默认的outline，如果想完全去除边框，可以设置border为none */
                    border: none;
                    /* 直接移除边框 */
                }
            }

            .btnbox {
                width: 40px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;

                img {
                    width: 30px;
                }
            }

            .skbtn {
                width: 50px;
                height: 40px;
                background-color: #fff;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0 10px;
            }

            .skbtned {
                background-color: #3D57A4;
                color: #fff;
            }


        }

    }
}

/deep/ .custom-markdown p {
    line-height: 22px;

    img {
        max-width: 98%;
    }
}

/deep/ .custom-markdown {
    img {
        max-width: 98%;
    }
}

/* ECharts图表加载状态样式 */
.echarts-container{
    position: relative;
}

.chart-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    border-radius: 8px;
}

.loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.loading-content .el-icon-loading {
    font-size: 24px;
    color: #409eff;
}

.loading-content span {
    color: #666;
    font-size: 14px;
}


@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(-20px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes pulse {
    0% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.05);
        opacity: 0.8;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

/* 响应式设计 */
@media (max-width: 768px) {
    .working {
        width: calc(100% - 30px);
        padding: 12px 16px;
    }
    
    .step-content {
        padding: 10px 12px;
    }
    
    .step-title {
        font-size: 13px;
    }
}
</style>
